import { useHook } from './hooks'
import styles from './styles.module.scss'
import { Row, Space, Image, Button } from 'antd'
import Search from '../../../components/SearchFilter'
import Buttonbar from '../../../components/ButtonBar'
import TableAntd from '../../../components/TableAntd'
import { GetLocalStorage } from '../../../tools/util'

const Launchbrand = () => {
  const {
    dataSource,
    pages,
    onJump,
    onSearch,
    onChange,
    onRefresh,
    nopassSwitch,
  } = useHook()

  const logoRender = (text: any) => {
    return (
      <Space>
        {text && (
          <Image
            width={100}
            height={40}
            src={GetLocalStorage('BASEURL') + text}
          />
        )}
      </Space>
    )
  }

  const mpmStateList = [
    {
      name: '审核中',
      value: '1',
    },
    {
      name: '驳回',
      value: '2',
    },
  ]

  const getMpmState = (text: string) => {
    const manage = mpmStateList.find((item) => item.value === text)
    return manage?.name
  }

  const columns = [
    {
      key: 'brandLogoUrl',
      dataIndex: 'brandLogoUrl',
      title: '品牌Logo',
      render: logoRender,
    },
    {
      key: 'brandCode',
      dataIndex: 'brandCode',
      title: '品牌编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brandNameCn',
      dataIndex: 'brandNameCn',
      title: '品牌中文名',
    },
    {
      key: 'brandNameEn',
      dataIndex: 'brandNameEn',
      title: '品牌英文名',
    },
    {
      key: 'mpmState',
      dataIndex: 'mpmState',
      title: '审核状态',
      render: getMpmState,
    },
    {
      key: 'mpmOperationTime',
      dataIndex: 'mpmOperationTime',
      title: '审核时间',
    },
    {
      key: 'mpmOperator',
      dataIndex: 'mpmOperator',
      title: '审核人',
    },
    {
      key: 'mpmComment',
      dataIndex: 'mpmComment',
      title: '审核说明',
    },
    {
      key: 'operation',
      title: '操作栏',
      width: 100,
      render: (text: any, record: any) => {
        return (
          <>
            {getMpmState(record.mpmState) === '驳回' && (
              <Button type="link" onClick={() => nopassSwitch(record.brandId)}>
                放弃
              </Button>
            )}
          </>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['brandCode', 'brandNameCn', 'brandNameEn', 'mpmState']}
        onSearch={onSearch}
        keyName="LAUNCHBRAND"
        ScreenKey="LAUNCHBRAND"
      />
      <div style={{ padding: '10px 10px' }}>
        <Row justify="space-between">
          <Space>
            <Buttonbar onRefresh={onRefresh}></Buttonbar>
          </Space>
        </Row>
        <TableAntd
          dataSource={dataSource.data}
          listColumn={columns}
          loading={dataSource.loading}
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}

export default Launchbrand
import { useHook } from './hooks'
import styles from './styles.module.scss'
import { Row, Space, Image, Button } from 'antd'
import Search from '../../../components/SearchFilter'
import Buttonbar from '../../../components/ButtonBar'
import TableAntd from '../../../components/TableAntd'
import { GetLocalStorage } from '../../../tools/util'

const Launchbrand = () => {
  const {
    dataSource,
    pages,
    onJump,
    onSearch,
    onChange,
    onRefresh,
    nopassSwitch,
  } = useHook()

  const logoRender = (text: any) => {
    return (
      <Space>
        {text && (
          <Image
            width={100}
            height={40}
            src={GetLocalStorage('BASEURL') + text}
          />
        )}
      </Space>
    )
  }

  const mpmStateList = [
    {
      name: '审核中',
      value: '1',
    },
    {
      name: '驳回',
      value: '2',
    },
  ]

  const getMpmState = (text: string) => {
    const manage = mpmStateList.find((item) => item.value === text)
    return manage?.name
  }

  const columns = [
    {
      key: 'brandLogoUrl',
      dataIndex: 'brandLogoUrl',
      title: '品牌Logo',
      render: logoRender,
    },
    {
      key: 'brandCode',
      dataIndex: 'brandCode',
      title: '品牌编码',
      render: (text: any, record: any) => (
        <span className="primaryBtn" onClick={() => onJump(record)}>
          {text}
        </span>
      ),
    },
    {
      key: 'brandNameCn',
      dataIndex: 'brandNameCn',
      title: '品牌中文名',
    },
    {
      key: 'brandNameEn',
      dataIndex: 'brandNameEn',
      title: '品牌英文名',
    },
    {
      key: 'mpmState',
      dataIndex: 'mpmState',
      title: '审核状态',
      render: getMpmState,
    },
    {
      key: 'mpmOperationTime',
      dataIndex: 'mpmOperationTime',
      title: '审核时间',
    },
    {
      key: 'mpmOperator',
      dataIndex: 'mpmOperator',
      title: '审核人',
    },
    {
      key: 'mpmComment',
      dataIndex: 'mpmComment',
      title: '审核说明',
    },
    {
      key: 'operation',
      title: '操作栏',
      width: 100,
      render: (text: any, record: any) => {
        return (
          <>
            {getMpmState(record.mpmState) === '驳回' && (
              <Button type="link" onClick={() => nopassSwitch(record.brandId)}>
                放弃
              </Button>
            )}
          </>
        )
      },
    },
  ]
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={['brandCode', 'brandNameCn', 'brandNameEn', 'mpmState']}
        onSearch={onSearch}
        keyName="LAUNCHBRAND"
        ScreenKey="LAUNCHBRAND"
      />
      <div style={{ padding: '10px 10px' }}>
        <Row justify="space-between">
          <Space>
            <Buttonbar onRefresh={onRefresh}></Buttonbar>
          </Space>
        </Row>
        <TableAntd
          dataSource={dataSource.data}
          listColumn={columns}
          loading={dataSource.loading}
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: onChange,
          }}
          showSize
        ></TableAntd>
      </div>
    </div>
  )
}

export default Launchbrand
